"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeOwnershipDisplay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var Tree_1 = require("./Tree");
var LookupValue_1 = require("../helpers/LookupValue");
var HomeOwnershipDisplay = /** @class */ (function (_super) {
    __extends(HomeOwnershipDisplay, _super);
    function HomeOwnershipDisplay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    HomeOwnershipDisplay.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Home ownership:  ", (0, jsx_runtime_1.jsx)(LookupValue_1.LookupValue, { type: "propertyOwnershipType", id: this.props.realEstate.ownershipType }), " "] }) });
    };
    return HomeOwnershipDisplay;
}(React.Component));
exports.HomeOwnershipDisplay = HomeOwnershipDisplay;
//# sourceMappingURL=HomeOwnershipDisplay.js.map